module.exports = __webpack_public_path__ + "static/media/phone.c0e2ce9e.png";